import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=79991690&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=79991690&prod&scoped=true&lang=css&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=79991690&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79991690",
  null
  
)

export default component.exports